import { Box, Table, TableBody, TableContainer } from "@mui/material";
import * as React from "react";
import { Row, Col, Button, Toggle} from "rsuite";
import UpSellRecommendationDetail from "./UpSellRecommendationDetail";
import UpSellRecommendationTable from "./UpSellRecommendationTable";

export class UpSellRecommendation extends React.Component<any, any> {
   
    constructor(props: any) {
        super(props);
        this.state = {
            checked: false,
            checked2: false,
            numberFormatter: null
        };
    }

    AsyncToggle = () => this.setState({ checked: !this.state.checked });

    AsyncToggleForExecution = () =>  this.setState({ checked2: !this.state.checked2 });

    render(): React.ReactNode {
        const { data, handleClick, setAdjustPoistionIconValue, levelFourData, dataToBeSave, handleUpSellSave,
             submitUpSellSellExecution, selectedL4Value, customerId, isUpSellRowHighlightingRequired, 
             isUpSellRowHighlighted, resettingValueWithIncludeBitForUpSell } = this.props;
        const {checked, checked2} = this.state;

        return <Row className="show-grid" style={{height:'100%'}}>
                    <Box height='12%'>
                        <Row className="show-grid" style={{paddingBottom: '5px'}}>
                            <Col xs={24} sm={24} md={8} />
                            <Col className="subHeadCU alignCenter" style={{ height: "15%", color: '#ffffff'  }} xs={24} sm={24} md={8}>
                                Recommendation Details
                            </Col>
                            <Col xs={24} sm={24} md={8} >
                                {data && <Button className="buttonMargin" color="green"
                                    style={{ float: "right", color: "white", marginRight: "3px", fontSize: "0.7vw", padding: "1.5% 3%" }}
                                    onClick={() => handleUpSellSave()} appearance="default">
                                    Save
                                </Button>}
                            </Col>
                        </Row>
                    </Box>
                    

                    {data ? (
                        <Box height={'73%'}>
                            <Row style={{height: '100%'}}>
                                <Row style={{paddingLeft: '10px', height: '100%'}} className="show-grid">
                                    <TableContainer id='recommendationData' style={{display: 'flex', width: '100%', height: '100%', overflow: 'hidden'}}>
                                        <Table  width='100%' style={{ height: '100%'}}>
                                            <TableBody style={{ display: 'flex', height: '100%'}}>
                                                <TableContainer style={{width: '47%', overflowX: 'hidden',
                                                 maxHeight: document.getElementById('recommendationData')?.clientHeight, overflowY: 'auto'}}>
                                                    <UpSellRecommendationTable {...data} handleClick ={handleClick}
                                                     isUpSellRowHighlightingRequired={isUpSellRowHighlightingRequired} isUpSellRowHighlighted={isUpSellRowHighlighted}/>
                                                </TableContainer>

                                                <TableContainer style={{width: '1%', border: 'none', height: '100%'}}/>

                                                <TableContainer style={{width:'51%', overflowX: 'hidden', 
                                                maxHeight: document.getElementById('recommendationData')?.clientHeight, overflowY: 'auto'}}>
                                                    <UpSellRecommendationDetail levelFourData ={levelFourData} dataToBeSave ={dataToBeSave} 
                                                    selectedL4Value= {selectedL4Value} customerId={customerId} setAdjustPoistionIconValue={setAdjustPoistionIconValue}
                                                    resettingValueWithIncludeBitForUpSell={resettingValueWithIncludeBitForUpSell}/>
                                                </TableContainer>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Row>
                            </Row>
                        </Box>
                     
                    ) : 
                    (<Row>
                            <Col>
                                <span className="divTextCenter">Click on the left Table to get the Detailed view</span>
                            </Col>
                            
                        </Row>
                    )} 

                    {data ? (
                    <Box height= {'15%'}>
                        <Row className="show-grid" style={{paddingTop: '15px', }}>
                            <Col style={{ color: "white" }} xs={24} sm={24} md={7} />

                            <Col style={{ color: "white" }} xs={24} sm={24} md={8}>
                                <label style={{ color: "#A4F504", fontSize: "0.75vw" }}>Agree with recommended info.: </label>
                                <Toggle style={checked ? {} : { backgroundColor: "#6b6a6a" }} checkedChildren="Yes" unCheckedChildren="No" checked={checked} onChange={this.AsyncToggle} />

                            </Col>
                            <Col xs={24} sm={24} md={6}>
                                <label style={{ color: "#A4F504", fontSize: "0.75vw" }}>Attempt Execution: </label>
                                <Toggle style={checked2 ? {} : { backgroundColor: "#6b6a6a" }} checkedChildren="Yes" unCheckedChildren="No" checked={checked2} onChange={this.AsyncToggleForExecution} />
                            </Col>
                            <Col xs={24} sm={24} md={3}>
                                <div style={{ paddingTop: "3px", textAlign: "left" }}>
                                    <Button className="buttonMargin" color="green" 
                                        style={{ float: "right", color: "white", marginRight: "3px", fontSize: "0.7vw", padding: "4% 19%" }} onClick={() =>
                                        submitUpSellSellExecution({
                                            isAgreed: this.state.checked ? 1 : 0,
                                            isExecuted: this.state.checked2 ? 1 : 0
                                        })} appearance="default">Submit</Button>
                                </div>
                            </Col>
                        </Row>
                    </Box>
                   ) : <></>}
                </Row>
        
    }
    
}

